import {createSelector} from 'reselect';
import {Store} from '../../redux/reducers';
import {initialState} from './reducer';

const select = (state: Store) => state.login || initialState;

const makeSelectToken = () =>
  createSelector(select, substate => substate.token);

const makeSelectRole = () => createSelector(select, substate => substate.role);

const makeSelectLoading = () =>
  createSelector(select, substate => substate.loading);

const makeSelectError = () =>
  createSelector(select, substate => substate.error);

export default select;
export {makeSelectToken, makeSelectRole, makeSelectLoading, makeSelectError};
